module.exports = __webpack_public_path__ + "img/KENDJI_15s.14cd72dc.jpg";